/* eslint-disable */
// @ts-nocheck

/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'

import { ExclamationCircleIcon } from '@heroicons/react/20/solid'

interface InputProps {
  label?: string
  placeholder?: string
  currencies: string[]
  defaultCurrency?: string | null
  showInline?: boolean
  disabled?: boolean
  byDefault?: { amount: number; codeCurrency?: string }
  min?: number
  max?: number
  className?: string
  defaultValue?: any
}

const CurrencyAmountInput = (props: UseControllerProps & InputProps) => {
  const {
    label,
    placeholder,
    currencies,
    showInline,
    disabled,
    byDefault,
    min,
    max,
    defaultCurrency,
    className,
    defaultValue = 0,
  } = props
  const { field, fieldState } = useController(props)

  const [input, setInput] = useState<{ amount: string; codeCurrency: string }>({
    amount: defaultValue,
    codeCurrency: byDefault?.codeCurrency ?? defaultCurrency ?? currencies[0],
  })

  /* useEffect(() => {
    if (field.value === undefined) {
      setInput({
        amount: "",
        codeCurrency:
          byDefault?.codeCurrency ?? defaultCurrency ?? currencies[0],
      });
    }
  }, [field.value]);*/

  useEffect(() => {
    if (byDefault) {
      field.onChange({
        amount: byDefault.amount,
        codeCurrency:
          byDefault?.codeCurrency ?? defaultCurrency ?? currencies[0],
      })
      setInput({
        amount: byDefault?.amount?.toString(),
        codeCurrency: byDefault?.codeCurrency ?? currencies[0],
      })
    } else if (defaultCurrency && !byDefault) {
      /*field.onChange({
        codeCurrency: defaultCurrency,
      });*/
      setInput({
        amount: '',
        codeCurrency: defaultCurrency,
      })
    }
  }, [])

  useEffect(() => {
    if (defaultValue) {
      setInput({
        amount: defaultValue,
        codeCurrency: defaultCurrency ?? '',
      })
    }
  }, [defaultValue, defaultCurrency])

  const onChangeHelper = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const position = value.length - 1
    const code = value.charCodeAt(position)

    if (
      (code >= 48 && code <= 57) ||
      code === 45 ||
      code === 46 ||
      value === ''
    ) {
      if (code === 45 && value.includes('-') && position !== 0) return
      if (code === 46 && value.includes('.') && value.indexOf('.') !== position)
        return
      if (max && Number(e.target.value) > max) return
      if (min && Number(e.target.value) < min) return
      setInput({ ...input, amount: value })
      field.onChange({
        amount: Number(e.target.value),
        codeCurrency:
          field?.value?.codeCurrency ?? defaultCurrency ?? currencies[0],
      })
    }
  }

  return (
    <div
      className={`${
        showInline ? 'inline-flex items-center' : 'flex-col'
      } w-full py-1 ${className ? className : ''}`}
    >
      {label && (
        <label
          className="block text-sm font-medium text-gray-700"
          htmlFor={label}
        >
          {label}
        </label>
      )}
      <div className="relative rounded-md shadow-sm">
        <input
          className={`${
            fieldState.error
              ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-400 text-gray-500 focus:border-gray-600 focus:ring-gray-500'
          } block w-full rounded-md pr-10 placeholder:text-slate-400 sm:text-sm`}
          disabled={disabled}
          onChange={onChangeHelper}
          placeholder={placeholder && placeholder}
          type="text"
          value={input.amount}
        />
        <div className="absolute right-0 top-0 flex items-center gap-1 pr-0">
          {fieldState.error && (
            <ExclamationCircleIcon
              aria-hidden="true"
              className="h-5 w-5 text-red-500"
            />
          )}

          <select
            className="rounded-md border-transparent bg-transparent py-2 pl-2 pr-7 text-gray-500 focus:border-slate-500 focus:ring-slate-500 sm:text-sm"
            disabled={disabled}
            onChange={(e) => {
              setInput({ ...input, codeCurrency: e.target.value })
              field.onChange({ ...field.value, codeCurrency: e.target.value })
            }}
            value={input.codeCurrency}
          >
            {currencies?.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        {fieldState.error && (
          <p className="absolute text-xs text-red-600">
            {fieldState.error?.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default CurrencyAmountInput
